import { IconType } from './Icon.types'
import { ReactComponent as PlusSvg } from '../../../../assets/svg/plus.svg'
import { ReactComponent as ArrowForwardSvg } from '../../../../assets/svg/arrow-right.svg'
import { ReactComponent as ArrowDownSvg } from '../../../../assets/svg/arrow-down.svg'
import { ReactComponent as ArrowLeftSvg } from '../../../../assets/svg/arrow-left.svg'
import { ReactComponent as PinOutlineSvg } from '../../../../assets/icons/pin.svg'
import { ReactComponent as ChevronRightSvg } from '../../../../assets/icons/chevron-right.svg'
import { ReactComponent as MoreVerticalSvg } from '../../../../assets/icons/more-vertical.svg'
import { ReactComponent as ReceiptOutlineSvg } from '../../../../assets/icons/receipt-outline.svg'
import { ReactComponent as StarOutlineSvg } from '../../../../assets/icons/star-outline.svg'
import { ReactComponent as FullStarSvg } from 'src/assets/svg/full-star.svg'
import { ReactComponent as EditOutlineSvg } from '../../../../assets/icons/edit-outline.svg'
import { ReactComponent as ShoppingBasketOutlineSvg } from '../../../../assets/svg/coreUx/ordersHub/shoppingBasketOutline.svg'
import { ReactComponent as CheckmarkOutlineSvg } from '../../../../assets/svg/coreUx/ordersHub/checkmarkOutline.svg'
import { ReactComponent as ChefHatOutlineSvg } from '../../../../assets/svg/coreUx/ordersHub/chefHatOutline.svg'
import { ReactComponent as PackageDeliveryOutlineSvg } from '../../../../assets/svg/coreUx/ordersHub/packageDeliveryOutline.svg'
import { ReactComponent as SearchFilledSvg } from '../../../../assets/svg/search-filled.svg'
import { ReactComponent as HeartOutlineSvg } from '../../../../assets/svg/rating/empty-heart.svg'
import { ReactComponent as HeartFilledSvg } from '../../../../assets/svg/rating/full-heart.svg'
import { ReactComponent as SettingsOutlineSvg } from '../../../../assets/svg/settings.svg'
import { ReactComponent as FaqsSvg } from '../../../../assets/svg/help.svg'
import { ReactComponent as NoResultsIcon } from 'src/assets/svg/menu-search/no-results.svg'
import { ReactComponent as MealDeliverySvg } from 'src/assets/svg/manageOrder/meal-delivery.svg'
import { ReactComponent as CheckedTruckSvg } from 'src/assets/svg/manageOrder/checked-truck.svg'
import { ReactComponent as CalendarDateSvg } from 'src/assets/svg/manageOrder/calendar-date.svg'
import { ReactComponent as PauseClockSvg } from 'src/assets/svg/manageOrder/pause-clock.svg'
import { ReactComponent as CloseOutlineSvg } from 'src/assets/svg/close.svg'
import { ReactComponent as ArrowForwardOutlineSvg } from 'src/assets/svg/arrow-forward-outline.svg'
import { ReactComponent as WineGlassSvg } from 'src/assets/svg/wine-glass.svg'

import { ReactComponent as Vegan } from 'src/assets/svg/tags/vegan.svg'
import { ReactComponent as Vegetarian } from 'src/assets/svg/tags/vegetarian.svg'
import { ReactComponent as Spicy } from 'src/assets/svg/tags/spicy.svg'
import { ReactComponent as Strict } from 'src/assets/svg/mealcard/Strict.svg'
import { ReactComponent as Info } from 'src/assets/svg/info-empty-circled.svg'
import { ReactComponent as DietPescatarian } from 'src/assets/svg/tags/pescatarian.svg'
import { ReactComponent as DietPaleo } from 'src/assets/svg/tags/paleo.svg'
import { ReactComponent as DietKeto } from 'src/assets/svg/tags/keto.svg'
import { ReactComponent as DietMediterranean } from 'src/assets/svg/tags/mediterranean.svg'
import { ReactComponent as ClimateFriendly } from 'src/assets/svg/tags/climate-friendly.svg'
import { ReactComponent as LowEmissions } from 'src/assets/svg/tags/low-emission.svg'
import { ReactComponent as InfoSkipped } from 'src/assets/svg/info-skipped.svg'

const IconAssetByIconType: Partial<Record<
  IconType,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
>> = {
  [IconType.ArrowForwardOutline]: ArrowForwardOutlineSvg,
  [IconType.ArrowLeft]: ArrowLeftSvg,
  [IconType.ArrowRight]: ArrowForwardSvg,
  [IconType.ChevronDown]: ArrowDownSvg,
  [IconType.ChevronRight]: ChevronRightSvg,
  [IconType.HeartOutline]: HeartOutlineSvg,
  [IconType.HeartFilled]: HeartFilledSvg,
  [IconType.NoResults]: NoResultsIcon,
  [IconType.Faqs]: FaqsSvg,
  [IconType.PinOutline]: PinOutlineSvg,
  [IconType.MoreVerticalOutline]: MoreVerticalSvg,
  [IconType.ReceiptOutline]: ReceiptOutlineSvg,
  [IconType.StarOutline]: StarOutlineSvg,
  [IconType.Star]: FullStarSvg,
  [IconType.EditOutline]: EditOutlineSvg,
  [IconType.ShoppingBasketOutline]: ShoppingBasketOutlineSvg,
  [IconType.CheckmarkOutline]: CheckmarkOutlineSvg,
  [IconType.ChefHatOutline]: ChefHatOutlineSvg,
  [IconType.PackageDeliveryOutline]: PackageDeliveryOutlineSvg,
  [IconType.PlusOutline]: PlusSvg,
  [IconType.SettingsOutline]: SettingsOutlineSvg,
  [IconType.SearchFilled]: SearchFilledSvg,
  [IconType.MealDelivery]: MealDeliverySvg,
  [IconType.CheckedTruck]: CheckedTruckSvg,
  [IconType.CloseOutline]: CloseOutlineSvg,
  [IconType.CalendarDate]: CalendarDateSvg,
  [IconType.PauseClock]: PauseClockSvg,
  [IconType.WineGlass]: WineGlassSvg,
  [IconType.Vegan]: Vegan,
  [IconType.Vegetarian]: Vegetarian,
  [IconType.Spicy]: Spicy,
  [IconType.Strict]: Strict,
  [IconType.Info]: Info,
  [IconType.InfoSkipped]: InfoSkipped,
  [IconType.DietPescatarian]: DietPescatarian,
  [IconType.DietPaleo]: DietPaleo,
  [IconType.DietKeto]: DietKeto,
  [IconType.DietMediterranean]: DietMediterranean,
  [IconType.ClimateFriendly]: ClimateFriendly,
  [IconType.LowEmissions]: LowEmissions
}

export const mapIconTypeToAsset = (
  iconType: IconType
): React.ComponentType<React.SVGProps<SVGSVGElement>> | null =>
  IconAssetByIconType[iconType] || null
